import React, { type ReactNode } from "react";

export const NBFC_URL = "https://fintechcloud.com/";

const companyNBFC = (import.meta.env.VITE_COMPANY_NBFC || "").trim();

export const NBFCLink: React.FC<{ className?: string; children?: ReactNode }> = ({ className, children }) => (
  <a
    href={NBFC_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={className ?? "underline hover:text-[var(--primary)]"}
  >
    {children ?? companyNBFC}
  </a>
);

// Wraps every occurrence of the NBFC name inside a plain string with a link to the NBFC website
export const linkifyNBFC = (text: ReactNode): ReactNode => {
  if (typeof text !== "string" || !companyNBFC) return text;

  const parts = text.split(companyNBFC);
  if (parts.length === 1) return text;

  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 && <NBFCLink />}
    </React.Fragment>
  ));
};
